import { IconCaret } from '@components/icons';
import { Disclosure, DisclosureButton, DisclosurePanel, Transition } from '@headlessui/react';
import classNames from 'classnames';

import { CARD_DISCLOSURE__ICON_TESTID } from '../tests/util';

import { CardDisclosureProps, VARIANTS } from './card-disclosure.type';

export const CardDisclosure = ({
  isDefaultOpen = false,
  isSticky = false,
  handleChangeVisibility,
  showChevronIcon = true,
  icon,
  titleText,
  descriptionText,
  paddingDescription = 'pt-7',
  widthClassName = 'w-full',
  disclosurePadding = 'p-4',
  marginClassNames = '',
  variant,
}: CardDisclosureProps) => {
  const Icon = icon?.icon;
  const variantSelected = VARIANTS[variant];
  return (
    <Disclosure
      as='div'
      defaultOpen={isDefaultOpen}
      className={classNames(
        'text-subtitle-s',
        disclosurePadding,
        widthClassName,
        marginClassNames,
        variantSelected.background,
        variantSelected.textColor,
        {
          'rounded-lg': !isSticky,
          'fixed bottom-0 left-0 shadow-[-2px_2px_16px_0_rgba(0,0,0,0.25)]': isSticky,
        }
      )}>
      {({ open }) => {
        if (handleChangeVisibility) handleChangeVisibility(open);
        return (
          <>
            <DisclosureButton className='flex w-full justify-between rounded-lg text-left font-extrabold '>
              <div className='flex items-center gap-x-2'>
                {Icon && (
                  <Icon
                    data-testid={CARD_DISCLOSURE__ICON_TESTID}
                    className={`${variantSelected.textColor} ${icon.width} ${icon.height}`}
                    {...icon.props}
                  />
                )}
                <span dangerouslySetInnerHTML={{ __html: titleText }} />
              </div>
              {showChevronIcon && !!descriptionText && (
                <IconCaret
                  className={`${open ? '-rotate-90' : 'rotate-90 '} transform h-5 w-5 ${variantSelected.textColor}`}
                />
              )}
            </DisclosureButton>
            {descriptionText && (
              <Transition
                enter='transition duration-100 ease-out'
                enterFrom='transform scale-95 opacity-0'
                enterTo='transform scale-100 opacity-100'
                leave='transition duration-75 ease-out'
                leaveFrom='transform scale-100 opacity-100'
                leaveTo='transform scale-95 opacity-0'>
                <DisclosurePanel as='div' className={`flex gap-x-2 font-normal ${paddingDescription}`}>
                  <span className='whitespace-pre-line'>{descriptionText}</span>
                </DisclosurePanel>
              </Transition>
            )}
          </>
        );
      }}
    </Disclosure>
  );
};
